import { useEffect, useRef, useState } from 'react';

import { isAttachmentResponse } from '@entities/task/lib/isAttachmentResponse';
import { downloadFile, getNameExtension } from '@shared/helpers';

import { getIframeSrc } from '../getIframeSrc';

export const useFilePreviewer = ({ onDeleteFile, onHide, currentFile, fileIdToPreview }) => {
    const [deleteConfirmModal, setDeleteConfirmModal] = useState(false);
    const [previewUrl, setPreviewUrl] = useState('');
    const ref = useRef(null);

    const isFromClient = currentFile && 'file' in currentFile;
    const isImage = isFromClient
        ? currentFile?.file?.type?.startsWith('image/')
        : isAttachmentResponse(currentFile) && currentFile.mime_type.startsWith('image/');
    const { extension, name } = getNameExtension(
        isAttachmentResponse(currentFile) && currentFile.name
    );
    const isPdf = extension === 'pdf';
    const iFrameSrc = getIframeSrc(extension);

    useEffect(() => {
        if (!currentFile) return;

        if (isFromClient && 'file' in currentFile) {
            const url = URL.createObjectURL(currentFile.file);
            setPreviewUrl(url);
            return () => URL.revokeObjectURL(url);
        }

        if (!isFromClient && 'original_url' in currentFile) {
            setPreviewUrl(currentFile.original_url);
        }
    }, [currentFile, isFromClient]);

    const handleDelete = () => {
        onDeleteFile(fileIdToPreview);
        setDeleteConfirmModal(false);
        onHide();
    };

    const handleDownload = async () => {
        if (!currentFile) return;

        const fileSource = isFromClient
            ? currentFile.file
            : isAttachmentResponse(currentFile)
            ? currentFile.original_url
            : '';

        const fileName = isFromClient
            ? currentFile.file.name
            : isAttachmentResponse(currentFile) && currentFile.name;

        if (fileSource) {
            await downloadFile(fileSource, fileName);
        }
    };

    const decodeNameFile = decodeURI(
        isFromClient
            ? currentFile?.file?.name
            : isAttachmentResponse(currentFile) && currentFile?.name
    );

    return {
        deleteConfirmModal,
        previewUrl,
        ref,
        isImage,
        isPdf,
        isFromClient,
        name,
        iFrameSrc,
        handleDelete,
        handleDownload,
        decodeNameFile,
        setDeleteConfirmModal,
    };
};
